import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

import { findChanges } from 'partner360/features/competitorsSob/helpers/findChanges'

import { selectCompetitorsSobState } from './selectCompetitorsSobState'

export const selectSobCompetitorsChangesFields = createSelector(
  [selectCompetitorsSobState, selectConfigurationState],
  ({ data, initialData }, { programType }) => {
    const dataByProgramType = data[programType] || []
    const initialDataByProgramType = initialData[programType] || []
    return findChanges(dataByProgramType, initialDataByProgramType)
  }
)
